
/**
 * Downloads a json file with all the countries and sets into the select input
 */
const loadCountriesForContactForm = () => {

    const dataSource = document.querySelector('#data-form-js');
    if(typeof dataSource === 'undefined' || dataSource === null) {
        window.setTimeout(loadCountriesForContactForm, 350);
        return;
    }

    fetch(dataSource.getAttribute('data-countries-url'))
        .then((response) => response.json())
        .then((data) => {
          const selectElement = document.getElementById(dataSource.getAttribute('data-form-id') + '-country');
          let hasSelectedCountry = false;
    
          data.countries.forEach((country) => {
            const option = document.createElement('option');
            option.value = country.es_name;
            option.textContent = country.es_name;
            selectElement.appendChild(option);
          });

          if (!hasSelectedCountry) {
            selectElement.querySelector('option[value="España"]').selected = true;
          }
        })
        .catch((error) => console.error('Error al cargar el archivo JSON:', error));
}

loadCountriesForContactForm();

const checkboxAcceptTerms = () => {
  var checkbox = document.getElementById('checkbox_accept_terms');
  var boton = document.getElementById('button_accept_terms');

  checkbox.addEventListener('change', function() {
    if (checkbox.checked) {
      boton.disabled = false;
    } else {
      boton.disabled = true; 
    }
  });

  boton.disabled = true;
}

checkboxAcceptTerms();


const changeColorOption1 = () => {

  var select = document.querySelector('.selected-active-1');
    select.classList.add('select-active');
};

const changeColorOption2 = () => {

  var select = document.querySelector('.selected-active-2');
    select.classList.add('select-active');
};